export default "__VITE_ASSET__Dbe43xPM__"